<template>
  <div
    class="d-inline-block sv-badge-container"
    :class="pointer ? 'cursor-pointer' : ''"
  >
    <template v-if="tooltip">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span
            v-if="html"
            class="sv-badge"
            :class="getClass"
            v-on="on"
            v-html="text"
          />
          <span v-else class="sv-badge" :class="getClass" v-on="on">
            {{ text }}
          </span>
        </template>
        <span>{{ tooltip }} </span>
      </v-tooltip>
    </template>
    <template v-else>
      <span class="sv-badge" :class="getClass">
        {{ text }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: "Badge",
  props: {
    text: {
      type: [String, Number],
      required: true
    },
    status: {
      type: String,
      default: "neutral"
    },
    tooltip: {
      type: String,
      default: null
    },
    html: {
      type: Boolean,
      default: false
    },
    pointer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getClass() {
      const st = this.status;
      return `sv-badge-${st}`;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/branding.scss";

.sv-badge {
  display: inline-block;
  font-family: "Roboto Condensed";
  font-size: 14px;
  border-radius: 14px;
  padding: 1px 12px;
  margin: 4px 4px;
  text-align: center;
  user-select: none;
  white-space: nowrap;
}
.sv-badge-container:first-child .sv-badge {
  margin-left: 0;
}
.sv-badge-container:last-child .sv-badge {
  margin-right: 0;
}
.sv-badge-neutral {
  color: $brand-text;
  background-color: $brand-menu-selected-text;
  border: 1px solid $brand-border;
}
.sv-badge-ok {
  color: $brand-status-success;
  background-color: $brand-status-success-add;
  border: 1px solid $brand-status-success;
}
.sv-badge-error {
  color: $brand-status-danger;
  background-color: $brand-status-danger-add;
  border: 1px solid $brand-status-danger;
}
.sv-badge-warning {
  color: $brand-status-warning;
  background-color: $brand-status-warning-add;
  border: 1px solid $brand-status-warning;
}
.sv-badge-info {
  color: $brand-status-info;
  background-color: $brand-status-info-add;
  border: 1px solid $brand-status-info;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
